import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CONTACT_SUPPORT } from "./documentationOverviewContent";
import { SECTION_SPACING } from "./overviewTokens";

export function NeedMoreHelpSection() {
  const { icon: Icon, title, description, cta } = CONTACT_SUPPORT;

  return (
    <section
      aria-labelledby="doc-help-title"
      className={`${SECTION_SPACING} rounded-2xl border border-primary/15 bg-gradient-to-br from-primary/5 via-white to-blue-50 p-6 md:p-8`}
    >
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
        <div className="flex items-start gap-4">
          <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-white text-primary shadow-xs ring-1 ring-primary/10">
            <Icon className="h-5 w-5" />
          </div>
          <div>
            <h2 id="doc-help-title" className="font-heading text-xl font-bold text-slate-900">
              {title}
            </h2>
            <p className="mt-1 max-w-2xl text-sm text-slate-600 leading-relaxed">{description}</p>
          </div>
        </div>

        <Link
          to={cta.to}
          className="inline-flex flex-shrink-0 items-center gap-2 self-start rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground shadow-sm transition-all duration-200 ease-out hover:bg-primary-600 hover:shadow-md active:scale-[0.98]"
        >
          {cta.label}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
